





























import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator'
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import {FieldType,Filter,CompareType} from '@/store/entities/filter'
import PageRequest from '@/store/entities/page-request'
import ajax from '@/lib/ajax'
import userAjax from '@/lib/userAjax'
@Component({})
export default class Rolesdescription extends AbpBase{
    roleTypes:any=[];
    filters:Filter[]=[
        {Type:FieldType.String,Value:'',FieldName:'Name',CompareType:CompareType.Contains},
        {Type:FieldType.String,Value:'',FieldName:'DisplayName',CompareType:CompareType.Contains},
        {Type:FieldType.Boolean,Value: true,FieldName:'allowLowEdit',CompareType:CompareType.Equal},
    ]
    get list(){
        return this.$store.state.role.list;
    };
    get loading(){
        return this.$store.state.role.loading;
    }
    async getRoleType() {
        let rep = await ajax.get('/api/services/app/AbpDataDict/GetList', {
            params: {
                filter: 'itemType=="RoleType"'
            }
        })
        this.roleTypes = rep.data.result.items
        return rep.data.result.items
    }
    pageChange(page:number){
        this.$store.commit('role/setCurrentPage',page);
        this.getpage();
    }
    pagesizeChange(pagesize:number){
        this.$store.commit('role/setPageSize',pagesize);
        this.getpage();
    }
    async getpage(){
        let where= Util.buildFilters(this.filters);
        let pagerequest=new PageRequest();
        pagerequest.maxResultCount=this.pageSize;
        pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
        pagerequest.where=where;
        await this.$store.dispatch({
            type:'role/getAll',
            data:pagerequest
        })
    }
    get pageSize(){
        return this.$store.state.role.pageSize;
    }
    get totalCount(){
        return this.$store.state.role.totalCount;
    }
    get currentPage(){
        return this.$store.state.role.currentPage;
    }
    //
    columns=[{
        title:'角色名',
        key:'name',
        width: 150,
    },{
        title:'显示名',
        key:'displayName',
        width: 150,
    },{
        title: '分组',
        width: 100,
        render: (h:any, params:any) => {
            let type = ''
            // 获取不到 this.roleTypes
            let roleTypes = [
                {itemCode: '1', itemName: '区域'},
                {itemCode: '2', itemName: '总部'},
                {itemCode: '0', itemName: '个人'},
            ]
            
            roleTypes.forEach((item:any) => {
                if (item.itemCode == params.row.roleType) {
                    type = item.itemName
                }
            })
            return h('span', type)
        }
    },{
        title:'权限菜单',
        key:'description'
    }]
    async created(){
        await this.getRoleType()
        this.getpage()
    }
}
